import React from 'react';
import styles from './styles.module.css';
import { Grid } from '@mui/material';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { useTranslation } from 'react-i18next';

function SuccessDialog({ onClose }) {
  const { t: tPopup } = useTranslation('popup');
  return (
    <div className={styles.popUp}>
      <Grid container className={styles.contentWrapperXs}>
        <Grid item xs={12} display="flex" justifyContent="flex-end" rowGap={1}>
          <ClearRoundedIcon onClick={onClose} className={styles.closeIcon} />
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="center">
          <h2>{tPopup('Thank you for your time!')}</h2>
        </Grid>
        <Grid item xs={12} textAlign="center" pt={2}>
          <p>{tPopup('Your response has been recorded successfully. We appreciate your cooperation.')}</p>
        </Grid>
      </Grid>
    </div>
  );
}

export default SuccessDialog;
